var module = angular.module('octopusApp.configuration');

module.factory('systemUserFactory', function() {
    var systemUser = { 
        Id: 'users-system', 
        DisplayName: 'System', 
        Username: 'system', 
    };
    return systemUser;
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/factories/system_user_factory.js
// module id = 390
// module chunks = 1